
import {isMobileGameDevice} from '../hooks/useMobileGameViewport';
let counter=200000;
const stack:number[]=[];
export function next(){
 if(isMobileGameDevice())return ++counter;
 const value=(stack[stack.length-1]||99)+1;stack.push(value);return value;
}
export function release(value:number){
 if(value>=200000)return;
 let index=stack.indexOf(value);while(index!==-1){stack.splice(index,1);index=stack.indexOf(value);}
}
const shells='.item-mall-backdrop,.reward-backdrop,.gacha-overlay,.hy-world,[aria-modal="true"]';
const raise=(element:Element)=>{
 const panel=element.closest<HTMLElement>('.panel');
 const shell=(panel||element).closest<HTMLElement>(shells);
 if(shell)shell.style.zIndex=String(next());
 if(panel)panel.style.zIndex=String(next());
};
if(typeof document!=='undefined' && isMobileGameDevice()){
 document.addEventListener('pointerdown',event=>{if(event.target instanceof Element)raise(event.target);},true);
 const observer=new MutationObserver(records=>{for(const record of records)for(const node of Array.from(record.addedNodes)){
  if(!(node instanceof Element))continue;
  if(node.matches('.panel,'+shells))raise(node);
  node.querySelectorAll('.panel,'+shells).forEach(raise);
 }});
 observer.observe(document.documentElement,{childList:true,subtree:true});
}
